module.exports = __webpack_public_path__ + "static/stucco-edb8bf20a7067088e5df92ed3e60703a.png";